import type { ReactNode } from 'react';
import { Button } from './Button.js';

export type StatePanelVariant = 'default' | 'loading' | 'empty' | 'error';

export interface StatePanelProps {
  variant?: StatePanelVariant;
  title?: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
  children?: ReactNode;
}

export function StatePanel({
  variant = 'default',
  title,
  message,
  actionLabel,
  onAction,
  children,
}: StatePanelProps) {
  const isSpecial = variant === 'empty' || variant === 'error' || variant === 'loading';
  return (
    <div
      className={`ui-state-panel ${isSpecial ? `ui-state-panel--${variant}` : ''}`.trim()}
      role={variant === 'loading' ? 'status' : variant === 'error' ? 'alert' : undefined}
    >
      {title ? <h3 style={{ margin: '0 0 0.5rem', fontSize: '1.125rem' }}>{title}</h3> : null}
      {message ? <p style={{ margin: '0 0 1rem', color: 'var(--3ds-text-secondary)' }}>{message}</p> : null}
      {children}
      {actionLabel && onAction ? (
        <Button variant="primary" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </div>
  );
}
